import { ModuloEstudianteComponent } from "./modulo-estudiante/modulo-estudiante.component";
import { ModuloDocenteComponent } from "./modulo-docente/modulo-docente.component";
import { CRUDusuarioComponent } from "./crudusuario/crudusuario.component";
import { RegistroProfesoresComponent } from "./registro-profesores/registro-profesores.component";
import { LoginComponent } from "./login/login.component";
import { PrincipalComponent } from "./principal/principal.component";
import { RegistroComponent } from "./registro/registro.component";
import { NgModule, Component } from "@angular/core";
import { Routes, RouterModule, CanActivate } from "@angular/router";
import { HomeComponent } from "./home/home.component";
import { HttpClientModule } from "@angular/common/http";
import { ReporteComponent } from "./reporte/reporte.component";
import { MenureporteComponent } from "./menureporte/menureporte.component";
import { CrearEncuestaComponent } from "./crear-encuesta/crear-encuesta.component";
import { AdminComponent } from "./admin/admin.component";
import { Guard1Guard } from "src/guards/guard1.guard"; //para administrador
import { GuarddocentesGuard } from "./../guards/guarddocentes.guard";
import { GuardestudiantesGuard } from "src/guards/guardestudiantes.guard";
import { Guard3Guard } from "src/guards/guard3.guard"; //para ambos admin y docente
import { EncuestaAccessGuard } from "src/guards/guardencuestaslibres.guard"; //para ambos admin y docente
import { EncuestasLibresComponent } from "./encuestas-libres/encuestas-libres.component";
import { GuardcoordinadoresGuard } from "src/guards/guardcoordinadores.guard";
import { GuarddirectoresGuard } from "src/guards/guarddirectores.guard";
import { ModuloCoordinadorComponent } from "./modulo-coordinador/modulo-coordinador.component";
import { ModuloDirectorComponent } from "./modulo-director/modulo-director.component";
import { PaginaErrorComponent } from 'src/app/paginasError/paginaError.component';

const routes: Routes = [
  {
    path: "principal",
    component: PrincipalComponent, //encuestas libres sin login
  },
  {
    path: "encuestas/:id", //esta es para las encuestas que existen
    component: HomeComponent,
    canActivate: [EncuestaAccessGuard]
  },
  {
    path: "login", //ruta libre para cualquiera que se quiera loguear
    component: LoginComponent,
  },
  {
    path: "reporte",
    //canActivate: [Guard1Guard], //guard 1 para administrador
    component: ReporteComponent,
  },
  {
    path: "registro",
    component: RegistroComponent,
  },
  {
    path: "menuReporte",
    //canActivate: [Guard1Guard], //para adminsitrador
    component: MenureporteComponent,
  },
  {
    path: "",
    component: LoginComponent,
  },
  {
    path: "admin",
    canActivate: [Guard1Guard],
    component: AdminComponent,
  },
  {
    path: "registroprofesores",
    canActivate: [Guard1Guard],
    component: RegistroProfesoresComponent,
  },
  {
    path: "crud-usuario",
    canActivate: [Guard1Guard],
    component: CRUDusuarioComponent,
  },
  {
    path: "crear-encuesta",
    canActivate: [Guard3Guard],
    component: CrearEncuestaComponent,
  },
  {
    path: "modulo-docente",
    canActivate: [GuarddocentesGuard],
    component: ModuloDocenteComponent,
  },
  {
    path: "modulo-coordinador",
    canActivate: [GuardcoordinadoresGuard],
    component: ModuloCoordinadorComponent,
  },
  {
    path: "modulo-director",
    canActivate: [GuarddirectoresGuard],
    component: ModuloDirectorComponent,
  },
  {
    path: "modulo-estudiante",
    canActivate: [GuardestudiantesGuard],
    component: ModuloEstudianteComponent,
  },
  {
    path: "encuestas-libres",
    component: EncuestasLibresComponent,
  },
  { path: '403', component: PaginaErrorComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes), HttpClientModule],
  exports: [RouterModule],
})
export class AppRoutingModule {}
